__turbopack_context__.v({
  "className": "VerRLW_className",
  "variable": "VerRLW_variable",
});
